// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ipZrvD8yUHI3KOrhtBNF{flex-direction:column;height:100%;padding:0 30px;display:flex;position:relative}@media (max-width:992px){.ipZrvD8yUHI3KOrhtBNF{width:700px;margin:0}}@media (max-width:768px){.ipZrvD8yUHI3KOrhtBNF{width:100%;margin:0}}.FYCTijS52XYBKiFdNEhD{flex-direction:column;height:100%;padding:0 30px;display:flex;overflow:auto}.iFdHx4OikIuP8TEkC434{width:500px;margin:0 auto;padding:36px 20px 0}@media (max-width:992px){.iFdHx4OikIuP8TEkC434{width:540px}}.EdNnQlHcXU0_RtdzgwRv{width:500px;height:100%;margin:0 auto;overflow:auto}@media (max-width:992px){.EdNnQlHcXU0_RtdzgwRv{width:540px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `ipZrvD8yUHI3KOrhtBNF`,
	"content__sub": `FYCTijS52XYBKiFdNEhD`,
	"contentSub": `FYCTijS52XYBKiFdNEhD`,
	"localProgress": `iFdHx4OikIuP8TEkC434`,
	"section": `EdNnQlHcXU0_RtdzgwRv`
};
export default ___CSS_LOADER_EXPORT___;
